import React from "react";

interface MenuItemProps {
  label: string;
  key: string;
  icon: React.ReactNode;
  children?: any;
  allowedRoles?: string[];
  allowedDepartments?: string[];
  allowedPositions?: string[];
}

const MenuItem = ({
  label,
  key,
  icon,
  children,
  allowedRoles = [],
  allowedDepartments = [],
  allowedPositions = [],
}: MenuItemProps) => {
  return {
    label,
    key,
    icon,
    children,
    allowedRoles,
    allowedDepartments,
    allowedPositions,
  };
};

export default MenuItem;
